/**
 * Skriver flikar { namn, kolumner: [{key, header, width}], rader, wrap } till
 * en .xlsx för analys (AI, pandas, pivottabeller): fet rubrikrad, låst
 * första rad och autofilter på varje flik. Inga bilder – kopplingen till
 * logotyper och foton finns i kolumnerna logo_url och foto_url.
 *
 * byggAnalysArbetsbok är ren (ExcelJS skickas in) och går att testa i Node.
 */
import { laddaNerArbetsbok } from './leadsExcelExport';

const ORANGE = 'FFFF6B00';

export function byggAnalysArbetsbok(ExcelJS, blad, { exportedAt = new Date(), exportedBy = '' } = {}) {
  const wb = new ExcelJS.Workbook();
  wb.creator = exportedBy || 'LagbasN';
  wb.created = exportedAt;

  for (const b of blad) {
    const ws = wb.addWorksheet(b.namn, { views: [{ state: 'frozen', ySplit: 1 }] });
    ws.columns = b.kolumner.map(c => ({ key: c.key, header: c.header, width: c.width }));
    const head = ws.getRow(1);
    head.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    head.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: ORANGE } };
    head.alignment = { vertical: 'middle' };
    for (const r of b.rader) ws.addRow(r);
    for (const key of b.wrap || []) {
      ws.getColumn(key).alignment = { wrapText: true, vertical: 'top' };
    }
    if (b.kolumner.length) {
      ws.autoFilter = { from: { row: 1, column: 1 }, to: { row: 1, column: b.kolumner.length } };
    }
  }
  return wb;
}

export async function skrivAnalysExcel(blad, { fileName, exportedAt = new Date(), exportedBy = '' } = {}) {
  const ExcelJS = (await import('exceljs')).default;
  const wb = byggAnalysArbetsbok(ExcelJS, blad, { exportedAt, exportedBy });
  await laddaNerArbetsbok(wb, fileName || 'lagbasn-analys.xlsx');
}
